import request from './request'

export interface Contest {
  id: number
  title: string
  description: string
  start_time: string
  end_time: string
  status: 'upcoming' | 'running' | 'ended'
  type: 'public' | 'private'
  participant_count: number
  problem_count: number
  created_by: number
  created_by_username: string
  created_at: string
}

export interface ContestProblem {
  id: number
  problem_id: number
  title: string
  difficulty: string
  accepted_count: number
  submitted_count: number
  score: number
  order_index: number
}

export interface ContestRank {
  rank: number
  user_id: number
  username: string
  avatar: string
  total_score: number
  total_time: number
  problem_results: {
    problem_id: number
    status: string
    score: number
    submit_count: number
    first_accepted_time: number
  }[]
}

export interface ContestListRequest {
  page?: number
  page_size?: number
  status?: string
  keyword?: string
}

export interface ContestListResponse {
  list: Contest[]
  total: number
  page: number
  page_size: number
}

export interface ContestDetailResponse {
  contest: Contest
  problems: ContestProblem[]
  is_participated: boolean
}

export interface ContestRankResponse {
  rankings: ContestRank[]
  total: number
  page: number
  page_size: number
}

// 获取竞赛列表
export function getContestList(params: ContestListRequest) {
  return request.get<ContestListResponse>('/contests', { params })
}

// 获取竞赛详情
export function getContestDetail(id: number) {
  return request.get<ContestDetailResponse>(`/contests/${id}`)
}

// 参加竞赛
export function joinContest(id: number) {
  return request.post(`/contests/${id}/join`)
}

// 获取竞赛排行榜
export function getContestRank(id: number, params: { page?: number; page_size?: number }) {
  return request.get<ContestRankResponse>(`/contests/${id}/rank`, { params })
}

// 提交竞赛代码
export function submitContestCode(contestId: number, data: {
  problem_id: number
  language: string
  code: string
}) {
  return request.post(`/contests/${contestId}/submit`, data)
}
